/*@ngInject*/
const PeoplePickerSaveOnBlurDirective = function () {
    return {
        require: 'uiSelect',
        link: function ($scope, $element, attrs, $select) {
            let searchInput = $element.querySelectorAll('input.ui-select-search');

            let handleBlur = function () {
                let item,
                    taggingActivated = $select.tagging.isActivated,
                    isValidIndex = $select.activeIndex >= 0;

                if ($select.open && (taggingActivated || isValidIndex)) {
                    item = $select.items[$select.activeIndex];
                    if (item.isTag && item.valid) {
                        $select.select(item, $select.skipFocusser);
                    }
                }
            };

            searchInput.on('blur.peoplePicker', handleBlur);

            $scope.$on('$destroy', function () {
                searchInput.off('blur.peoplePicker', handleBlur);
            });
        }
    };
};

angular.module('umCore')
    .directive('peoplePickerSaveOnBlur', PeoplePickerSaveOnBlurDirective);
